
import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoFacilityOrderReasonForChangeModalStore } from 'application/niko-facility-order/stores';
import { NikoFacilityOrderReasonForChangeModalTemplate } from 'themes/application/niko-facility-order/components';

@setCurrentView((rootStore, componentProps) => new NikoFacilityOrderReasonForChangeModalStore(rootStore, componentProps), 'nikoFacilityOrderReasonForChangeModalStore')
@observer
class NikoFacilityOrderReasonForChangeModal extends React.Component {
    render() {
        return <NikoFacilityOrderReasonForChangeModalTemplate {...this.props} />
    }
}

export default NikoFacilityOrderReasonForChangeModal;
